import type { SvgIconProps } from '@mui/material';
import type { Variants } from 'motion/react';

export interface AnimeatableIconRef {
  startAnimation: () => Promise<unknown>;
  stopAnimation: () => Promise<unknown>;
}

export interface AnimatedIconProps {
  size?: number;
  strokeWidth?: number;
  /** Accessibility label for the icon */
  titleAccess?: string;
  /** MUI theme color */
  color?: SvgIconProps['color'];
  /** MUI fontSize prop — when provided, overrides `size` */
  fontSize?: SvgIconProps['fontSize'];
}

export const pathVariants: Variants = {
  visible: { pathLength: 1, opacity: 1 },
  hidden: { pathLength: 0, opacity: 0 },
};
